import { cyan } from "@material-ui/core/colors";
import React, { useState } from "react";
// import ReactHtmlParser from "react-html-parser";
// import parse from 'html-react-parser';

import TextField from "@material-ui/core/TextField";
import { ChangePassword } from "./ChangePassword";
import { getLoggedInUserName } from "../../apis/sessionUtil";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import UpdateProfile from "./UpdateProfile";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Grid from '@material-ui/core/Grid'


const style = {
  backgroundColor: "#4da6ff",
  width: "100%",
  height: 800,
};



export default ({show,setShow}) => {
  
   
  const [value, setValue] = useState(0);
  const [showChangePassword,setShowChangePassword] = useState(false);
  
  const [userGroups, setUserGroups] = useState([]);

  function onSubmit() {}

  function onClickChangePassword(){
    setShowChangePassword(true);
  }
  
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const tabSwitch =() => {
    switch (value) {
      case 0:
        return <UpdateProfile/>;
      case 1:
        return <ChangePassword/>;
    }
  }
  if (!show) {
    return "";
  }


  return (

       <div className="modal" >
       <div class="modal-content">
       <Tooltip title="Close">
          <IconButton
            style={{ float: "right", position: "absolute", right: 0, top: 0 }}
            onClick={() => setShow(false)}
          >
            <CloseOutlinedIcon />
          </IconButton>
        </Tooltip>
       <Grid container>
         <Grid item xs={12}>

         <Tabs variant="fullWidth" indicatorColor="primary"
                            textColor="primary" value={value} onChange={handleChange}>
              <Tab label="Update Profile"></Tab>
              <Tab label="Change Password"></Tab>
         </Tabs>
         {tabSwitch()}

         </Grid>
         </Grid>
          {/* <UpdateProfile/>
          <ChangePassword/> */}
          
      
        
       
       </div>
      </div>
  )
  
};
